import { render, staticRenderFns } from "./CirclePlus.vue?vue&type=template&id=2034bb2f"
import script from "./CirclePlus.vue?vue&type=script&lang=js"
export * from "./CirclePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports